import create, { SetState } from 'zustand';

export interface IDevStore {
  skeleton?: boolean;
  setSkeleton?(skeleton: boolean): void;
}

export const [useDevStore] = create<IDevStore>((set: SetState<IDevStore>) => ({
  skeleton: null,
  setSkeleton: (skeleton: boolean) =>
    set(() => {
      return {
        skeleton,
      };
    }),
}));
